/**
 * Header Service for Native Interactive Site Map
 *
 * Small visibility controller for the map header container (`[data-header]`).
 * It only restores visibility when this service instance hid the element,
 * preventing accidental overrides if another owner hid it first.
 *
 * @module nativeInteractiveSiteMap/services/headerService
 */

export default function createHeaderService(headerElement) {
  let hiddenByService = false;

  function hide() {
    if (!headerElement || headerElement.hidden) {
      return;
    }

    headerElement.hidden = true;
    hiddenByService = true;
  }

  function show() {
    if (!headerElement || !hiddenByService) {
      return;
    }

    headerElement.hidden = false;
    hiddenByService = false;
  }

  return {
    hide,
    show,
  };
}